import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as WarningIconImage } from './warning-icon.svg';
import SvgIconWrapper from '../../../components/icons/SvgIconWrapper';

const WarningIcon = ({ svgWrapperClassName, sx }) => (
  <SvgIconWrapper
    Icon={WarningIconImage}
    svgWrapperClassName={svgWrapperClassName}
    sx={sx}
  />
);

WarningIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  svgWrapperClassName: PropTypes.string,
};

WarningIcon.defaultProps = {
  sx: undefined,
  svgWrapperClassName: undefined,
};

export default WarningIcon;
